import { Grid } from '@material-ui/core';
import React from 'react';
import { breakpoints } from 'styles/breakpoints';
import BlockChip from './BlockChip';
import BlockChipMobile from './BlockChipMobile';

const BlockCase = ({
  data,
  activeChip,
  handleChipChange,
  widthWindow,
  scrollHandler,
}) => {
  const isMobile = `${breakpoints.values.md}`;

  if (widthWindow > isMobile) {
    return (
      <BlockChip
        data={data}
        activeChip={activeChip}
        handleChipChange={handleChipChange}
        scrollHandler={scrollHandler}
      />
    );
  } else {
    return (
      <Grid container justify={'center'} alignItems={'center'}>
        <BlockChipMobile
          data={data}
          activeChip={activeChip}
          handleChipChange={handleChipChange}
          scrollHandler={scrollHandler}
        />
      </Grid>
    );
  }
};
export default BlockCase;
